import React from "react"
import { CircularProgress } from "material-ui"
import autobind from "class-autobind"
import { IClientDocument } from "../../../models"
import ClientDetailsTopbar from "./ClientDetailsTopbar"
import ClientDetailsSummary from "./ClientDetailsSummary"
import ClientDetailsData from "./ClientDetailsData"
import * as api from "../../../api"
import * as permissionHelper from "../../../helpers/permissionHelper"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import AppStateStore from "../../../stores/AppStateStore"
import strings from "../../../localization/strings"
interface IProps {
    params: { clientId: string }
}
interface IState {
    client: IClientDocument
    showProgress: boolean
}

export default class ClientDetails extends React.Component<IProps, IState> {
    constructor(props, context) {
        super(props, context)
        this.state = {
            client: null,
            showProgress: true,
        }
        autobind(this)
    }

    componentDidMount() {
        document.title = `${strings.Client_Details} | ${strings.Findd_Grandd_Central}`
        this.getClient()
    }

    getClient(cb: Function = null) {
        api.getClient(this.props.params.clientId).then(res => {
            this.setState({
                showProgress: false,
                client: res.data
            })
            cb && cb()
        })
    }

    async handleUpdateClient(client: IClientDocument) {
       try {
        const response = await api.updateClient(client)
        this.setState({client: response.data})
       } catch (error) {
           AppStateStore.setProgressSnackbarContent(error.data.message)
       }
    }

    uploadClientLogo(imageData: string) {
        api.uploadClientLogo(this.state.client.Id, imageData).then(() => {
            this.getClient()
        })
    }

    removeClientLogo() {
        api.removeClientLogo(this.state.client.Id).then(() => {
            this.getClient()
        })
    }

    render() {
        return (
            <div className="page-container">
                {this.state.showProgress ?
                    <div className="spinner" style={{ display: "flex", flex: "1 1 100%", placeContent: "center", height: "75vh", paddingTop: "12em" }}>
                        <CircularProgress />
                    </div> :
                    <div className="user-details">
                        <ClientDetailsTopbar
                            client={this.state.client}
                        />
                        <ClientDetailsSummary
                            readonly={!permissionHelper.hasPermission(AuthenticationStore.Permissions.Clients.EditClients)}
                            client={this.state.client}
                            handleUpdateClient={this.handleUpdateClient}
                            uploadClientLogo={this.uploadClientLogo}
                            removeClientLogo={this.removeClientLogo}
                        />
                        <ClientDetailsData
                            readonly={!permissionHelper.hasPermission(AuthenticationStore.Permissions.Clients.EditClients)}
                            client={this.state.client}
                            reloadClient={this.getClient}
                        />
                    </div>
                }
            </div>
        )
    }
}